import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTermsContent = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.text.fourth} transparent`,
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  '&::-webkit-scrollbar': {
    width: theme.spacing(2),
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: theme.customShape.borderRadiusSmall,
    backgroundColor: theme.palette.text.fourth,
  },
}));

export const StyledTermsList = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

export const StyledTermsListItem = styled(Box)(({ theme }) => ({
  display: 'list-item',
  listStyleType: 'disc',
  paddingLeft: theme.spacing(2),
  whiteSpace: 'pre-line',
  '&::marker': {
    color: theme.palette.text.primary,
  },
}));
